import { inject } from '@angular/core';
import { ReasonService } from '../../reasons/reasons.service';
import { ResolveFn } from '@angular/router';

export const prospectiveAdminOutreachReasonsResolver: ResolveFn<void> = async () => {
  await inject(ReasonService).fetchAllProspectiveAdminReasonSelect();
}
